<template lang="pug">
button(:class="{ active, completed }", type="button", @click.prevent="navigate", :disabled="!navigable")
  span {{ item.label }}
  em(v-if="active") {{ item.label }}
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "NavigationItem",
  props: {
    item: Object,
    index: Number,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["formCompletionIndex"]),
    active() {
      return this.item.id === this.$route.params.slug;
    },
    completed() {
      return this.formCompletionIndex > this.index;
    },
    navigable() {
      return this.formCompletionIndex >= this.index
    }
  },
  methods: {
    navigate() {
      if (this.navigable) {
        this.$router.push(`/${this.item.id}`);
      }
    },
  },
  watch: {
    '$route.params.slug': {
      handler(slug) {
        if (this.item.id === slug) {
          this.$el.focus();
        }
      },
      deep: true
    },
    active(isActive) {
      const nav = this.$el.parentElement;
      const duration = 500;
      const startx = nav.scrollLeft;
      const destx = this.$el.offsetLeft;
      let stop = false;
      let start = null;

      if (isActive) {
        requestAnimationFrame(startAnim);
      }

      function startAnim(timeStamp) {
        start = timeStamp;
        doScroll(timeStamp);
      }

      function doScroll(now) {
        if (stop) return;
        if (now - start >= duration) stop = true;
        let p = (now - start) / duration;
        let val = easeInOutQuad(p);
        let x = startx + (destx - startx) * val;
        nav.scrollLeft = x;
        requestAnimationFrame(doScroll);
      }

      function easeInOutQuad(x) {
        return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
      }
    },
  },
  mounted() {
    if (this.item.id === this.$route.params.slug) {
      this.$el.focus();
    }
  }
};
</script>

<style scoped lang="scss">
button {
  all: unset;
  appearance: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-family: Rokkitt;
  cursor: default;
  counter-increment: navigation;
  flex: 1 1 0;
  margin: 0 auto;
  box-sizing: border-box;

  &:not(:disabled) {
    cursor: pointer;
  }

  &.active,
  &.completed:not(.active ~ *) {
    span {
      color: var(--active);
    }

    &::before {
      background: var(--active);
    }
  }

  &::before {
    content: counter(navigation);
    display: flex;
    justify-content: center;
    align-items: center;
    height: var(--counter-height);
    aspect-ratio: 1 / 1;
    border-radius: 50%;
    color: $white;
    font-size: 22px;
    background: var(--default);
    transition: 0.25s ease;

    @include mq(md) {
      font-size: 30px;
    }
  }

  span {
    @include fluid-type(768px, 991px, 18px, 22px);
    margin-top: 0.5rem;
    display: none;
    color: var(--default);
    white-space: nowrap;
    @include mq(md) {
      display: block;
    }
  }

  em {
    position: absolute;
    display: inline;
    color: var(--active);
    font-size: 20px;
    font-style: normal;
    left: 50%;
    top: 100%;
    transform: translateX(-50%) translateY(-150%);
    height: 20px;
    line-height: 1;

    @include mq(md) {
      display: none;
    }
  }
}

// button {
//   display: flex;
//   align-items: center;
//   appearance: none;
//   border: none;
//   padding: 0.75rem;
//   cursor: pointer;
//   counter-increment: navigation;
//   gap: 0.5rem 0.75rem;
//   color: $midnight;
//   background: $concrete;
//   flex: 1 1 0;
//   outline: none;
//   text-align: left;
//   margin: 0;
//   border-right: 2px solid $white;
//   transition: 0.35s ease;

//   &:focus {
//     outline: none;
//     &::before {
//       box-shadow: 0 0 0 3px $sky;
//     }
//   }

//   &:last-child {
//     flex: 0 0 auto;
//     grid-template-rows: min-content;
//     &::after {
//       display: none;
//     }
//   }

//   &::before {
//     content: counter(navigation);
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     align-self: start;
//     justify-self: start;
//     line-height: 1;
//     font-size: 0.875rem;
//     height: calc(1.5rem + 1px);
//     width: calc(1.5rem + 1px);
//     border-radius: 50%;
//     border: 1px solid currentColor;
//     grid-area: 1 / 1 / 2 / 2;
//     transition: 0.35s ease;
//     z-index: 2;
//     padding-top: 0.125rem;
//     padding-right: 0.0625rem;
//     flex: 0 0 auto;
//   }

//   &.active {
//     background: $midnight;
//     color: $white;
//   }

//   &.completed {
//     &::before {
//       content: "\f00c";
//       font-weight: 900;
//       font-family: "Font Awesome 5 Free";
//       -webkit-font-smoothing: antialiased;
//       font-style: normal;
//       font-variant: normal;
//       text-rendering: auto;
//       line-height: 1;
//     }
//   }

//   span {
//     display: flex;
//     grid-area: 1 / 2 / 2 / 3;
//     align-items: center;
//     justify-content: flex-start;
//     position: relative;
//     width: 100%;
//     height: 100%;
//     padding: 0;
//     white-space: nowrap;
//     line-height: 1;
//     transition: 0.35s ease;
//     z-index: 0;
//   }
// }
</style>
